import React from 'react';
import { ClickAwayListener, MenuList, Paper, SxProps, Theme } from '@mui/material';
import { palette, spaces } from '../../assets/styles/themes/tokens';

const paperProps = {
  sx: {
    borderRadius: spaces.md,
    border: `1px solid ${palette.elevation.outlined}`,
  },
  elevation: 4,
};

const menuListProps = {
  sx: {
    padding: spaces.xs,
  }
};

interface MenuProps {
  paperSx?: SxProps<Theme>;
  MenuListProps?: any;
  isOpen?: boolean;
  onClose?: (event: any, reason: 'backdropClick' | 'escapeKeyDown') => void;
}

const Menu: React.FC<MenuProps> = (props) => {
  return <>
    <Paper
      sx={{
        ...paperProps.sx,
        ...props.paperSx,
      }}
    >
      <ClickAwayListener onClickAway={() => {
        props.onClose && props.onClose({}, 'backdropClick');
      }}>
        <MenuList
          autoFocusItem={props.isOpen}
          {...menuListProps}
          {...props.MenuListProps}
        >
          {props.children}
        </MenuList>
      </ClickAwayListener>
    </Paper>
  </>;
};

export default Menu;
